const constants = {
  types: {
    BOOLEAN: typeof true,
    NUMBER: typeof 1,
    OBJECT: typeof {},
    STRING: typeof 'string',
    UNDEFINED: typeof undefined
  }
};

export default constants;

export const {
  types
} = constants;